import { createSelector } from "@reduxjs/toolkit";
import { State } from "redux/store";

const state = (state: State) => state.metadata;

export const getSelectedSection = createSelector(state, (state) => {
  return state.selectedSection;
});
